import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "../config/business";
import { useLanguage } from "../i18n/LanguageContext";

const WhatsAppFloat = () => {
  const { t } = useLanguage();

  return (
    <motion.a
      data-testid="floating-whatsapp-button"
      href={waLink(t.float.waMessage)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.float.label}
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.92 }}
      className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-[#3EE884] via-[#25D366] to-[#1FB859] text-[#052e16] shadow-[inset_0_1px_0_rgba(255,255,255,0.35),0_16px_36px_-10px_rgba(37,211,102,0.6),0_4px_10px_rgba(0,0,0,0.35)]"
    >
      <span className="animate-pulse-ring absolute inset-0 rounded-full bg-wa" />
      <MessageCircle className="relative h-7 w-7" strokeWidth={2.4} />
    </motion.a>
  );
};

export default WhatsAppFloat;
